import '../assets/NcCheckboxRadioSwitch-DArK1Q95.css';
import { r as register } from "./_l10n-DwEsZ6zb.mjs";
register();
